export type RangeOpts = {
  to: number;
  from?: number;
  step?: number;
  inclusive?: boolean;
};

/** Creates an array of numbers with specified range
 *
 * Examples:
 *```typescript
     range({to: 5}) = [0, 1, 2, 3, 4]
     range({from: 0, to: 3, inclusive: true}) = [0, 1, 2, 3]
     range({to: 10, step: 3}) = [0, 3, 6, 9]

 ```
 * */
export const range = (opts: RangeOpts) => {
  const inclusiveIncrement = +!!opts.inclusive;
  const from = opts.from || 0;
  const to =
    opts.to + (opts.to < from ? -inclusiveIncrement : inclusiveIncrement);
  const step = opts.step || 1;

  const result = [];

  if (to < from) {
    for (let i = from; i > to; i -= step) {
      result.push(i);
    }
  } else {
    for (let i = from; i < to; i += step) {
      result.push(i);
    }
  }
  return result;
};
